import {
  CurrentSceneReady,
  ListenAddPhrase,
  ListenForReactEvent,
  NotifyReact,
  ReactToExerciseEventType,
  RemoveListener,
} from "Phaser/EventBus";
import { INoteGraphicsDatabase, PlayingState } from "./StaffExercise";
import IPlayable from "Phaser/GameObjects/Playable";
import { PhraseData, PhraseGraphic } from "Phaser/GameObjects/StaffLine";
import CursorMobile, {
  EventStreamPhaser2,
  IteratorExtensible,
} from "Phaser/GameObjects/CursorMobile";
import { PrerenderedPhraseData } from "Types";
import Phrase, { Iterator } from "Models/Phrase";

export default class SightReading
  extends Phaser.Scene
  implements INoteGraphicsDatabase
{
  staffLines: PhraseGraphic[] = [];
  currentIdx?: number;
  cursor?: CursorMobile;
  eventStream?: EventStreamPhaser2;

  phrasesSeen: Set<string> = new Set();
  playingState?: PlayingState = undefined;

  indexBottom: number = 0;
  indexTop: number = 0;
  activePhrase: number = 0;

  // This is a hack for maintaining the correct sequence when new phrases get loaded in
  // should no longer be necessary once we get all the data baked in from the backend
  phraseToBeLoadedNext: {
    phrase: PhraseData;
    cursorData: PrerenderedPhraseData[];
    phraseRaw: Phrase;
  } | null = null;

  constructor() {
    super("SightReading");
  }

  getNoteById(id: string): IPlayable | null {
    console.debug(this.staffLines);
    for (let staff of this.staffLines) {
      const found = staff.getNoteById(id);
      if (found) return found;
    }
    return null;
  }

  getPhraseEndPosition() {
    return Math.max(
      ...this.staffLines.map((staffLine) => staffLine.getNextPosition())
    );
  }

  getNotePosition(id: string) {
    for (let staff of this.staffLines) {
      const found = staff.getNotePosition(id);
      if (found) return found;
    }
    return null;
  }

  create() {
    NotifyReact(CurrentSceneReady(this));
    this.events.once("shutdown", this.destroy, this);
  }

  destroy() {
    this.cursor?.destroy(true);
    RemoveListener(ReactToExerciseEventType.AddPhrase);
    this.playingState = undefined;
  }

  init() {
    this.currentIdx = 0;
    ListenForReactEvent(ListenAddPhrase(this.addPhrase), this, false, true);
  }

  addPhrase({
    phraseRaw,
    phrase,
    cursorData,
  }: {
    phraseRaw: Phrase;
    phrase: PhraseData;
    cursorData: PrerenderedPhraseData[];
  }) {
    if (phrase && !this.phrasesSeen.has(phrase.uuid)) {
      if (phrase.startTimestamp !== 0 && this.staffLines.length === 0) {
        this.phraseToBeLoadedNext = { phrase, cursorData, phraseRaw };
        return;
      }
      const x =
        this.currentIdx !== undefined
          ? this.staffLines[this.currentIdx].getNextPosition()
          : 100;
      this.currentIdx =
        this.currentIdx !== undefined ? (this.currentIdx + 1) % 4 : 0;
      console.log("index", this.currentIdx);

      console.log("position: ", x, this.currentIdx);
      const staff = new PhraseGraphic(
        this,
        0,
        {
          globalScaling: 1,
          pitchLineGap: 20,
          pitchLineWidth: 2,
          measureLineWidth: 3,
          phraseWidth: 1660,
          clefGap: 100,
          doubleEndLines: true,
        },
        phrase,
        "None"
        //cursorData
      );
      const cameraWidth = this.cameras.main.width;
      const cameraHeight = this.cameras.main.height;
      const centreX = cameraWidth / 2 - staff.getWidth() / 2;
      const centreY = cameraHeight / 2 - staff.getHeight() / 2;
      const verticalPadding = 20;
      const staffGap = 20;
      const availableVerticalSpace =
        cameraHeight - (verticalPadding * 2 + staffGap);
      const topPhrasePosition = verticalPadding;
      const bottomPhrasePosition =
        topPhrasePosition + staff.getHeight() + staffGap;
      //this.staffLines[this.bott]
      // Active phrase index:
      // 0: bottom
      // 1: top
      if (this.activePhrase == 0) {
        // we're currently playing through the bottom phrase
        // set the new phrase at the top
        this.staffLines[1] = staff;
        staff.setPosition(centreX, topPhrasePosition);
        this.indexTop = (this.indexTop + 1) % 2;
      } else {
        this.staffLines[0] = staff;
        staff.setPosition(centreX, bottomPhrasePosition);
        // fade out the existing staff at the bottom
        this.staffLines[this.indexBottom + 2].transition("Fade");
        this.indexBottom = (this.indexBottom + 1) % 2;
      }
      if (this.staffLines.length === 0) {
        this.staffLines[0] = staff;
      } else {
        if (this.staffLines.length >= 4 && this.currentIdx !== undefined) {
          console.log("destroyed", this.currentIdx);
          this.staffLines[this.currentIdx].destroy();
        }
        this.staffLines[this.currentIdx] = staff;
      }
      if (!this.cursor) {
        const cursorHeight = staff.getHeight() * 1.35;
        const cursorWidth = cursorHeight / 10;
        const cursorY = staff.getHeight() / 2 - cursorHeight / 2 + staff.y;
        const firstNotePosition = staff.getFirstNotePosition();
        this.cursor = new CursorMobile(
          this,
          firstNotePosition,
          cursorY,
          cursorWidth,
          cursorHeight,
          this.eventStream!,
          new IteratorExtensible(this, [], phraseRaw),
          true
        );
      }
      this.cursor?.addPhrase(cursorData);
      this.eventStream?.addEvents2(
        new Iterator(cursorData, phraseRaw),
        phraseRaw.getStartTimestamp()
      );
      this.phrasesSeen.add(phrase.uuid);
      console.log("added phrase ", phrase.phraseIdx, this.currentIdx);
      if (this.phraseToBeLoadedNext) {
        const phrase = this.phraseToBeLoadedNext;
        this.phraseToBeLoadedNext = null;
        this.addPhrase(phrase);
      }
      console.debug("adding phrase success");
    } else {
      console.debug(
        "adding phrase failed",
        phrase,
        this.phrasesSeen.has(phrase.uuid)
      );
    }
  }

  update() {}
}
